/** toggle sidebar **/
$(function(){
    let body = $("body");
    let sidebar = $("#cabinet__sidebar");
    let sidebarStatus = parseInt(sidebar.css('left')) < 0 ? false : true;
    let sidebarOverlay = $("#sidebar__overlay");
    let sidebarToggleBtn = $("#sidebar__toggle_btn");
    let showBtn = sidebarToggleBtn.find(".sidebar__show_btn");
    let hideBtn = sidebarToggleBtn.find(".sidebar__hide_btn");

    sidebarToggleBtn.on("click", () => !sidebarStatus ? sidebar_show() : sidebar_hide());
    sidebarOverlay.on("click", () => sidebar_hide());

    function sidebar_show() {
        body.css("overflow", "hidden");
        sidebar.animate({'left':0}, 200);
        sidebarOverlay.fadeIn(200);
        showBtn.addClass("d-none");
        hideBtn.removeClass("d-none");
        sidebarStatus = true;
    }
    function sidebar_hide() {
        body.css("overflow", "auto");
        sidebar.animate({'left': -sidebar.outerWidth() + 'px'}, 200);
        sidebarOverlay.fadeOut(200);
        hideBtn.addClass("d-none");
        showBtn.removeClass("d-none");
        sidebarStatus = false;
    }

    /* sidebar menu slideToggle */
    $(".sidebar__menu li.parent > a").on("click", function(e){
        let prnt = $(this).parent("li");
        $(".sidebar__menu li.parent").not($(prnt)).children("ul").slideUp(200);
        $(prnt).children("ul").slideToggle(200);
        return false;
    });
});
